module.exports = __webpack_public_path__ + "img/sisustajan-ale.b01ea14b.webp";